import { i18n } from '@lingui/core'

export const locales = {
    en: 'English',
    fr: 'Français',
} as const

export type SupportedLocale = keyof typeof locales

export const defaultLocale: SupportedLocale = 'en'

/**
 * Load messages for requested locale and activate it.
 * This function isn't part of the LinguiJS library because there are
 * many ways how to load messages — from REST API, from file, from cache, etc.
 */
export async function loadCatalog(locale: SupportedLocale): Promise<void> {
    const { messages } = await import(`./locales/${locale}/messages.po`)
    i18n.loadAndActivate({ locale, messages })
    if (typeof document !== 'undefined') {
        document.documentElement.lang = locale
    }
}

/**
 * Get the browser's preferred locale if supported, otherwise return default
 */
export function detectLocale(): SupportedLocale {
    const lang = navigator.language?.split('-')[0]
    if (lang && lang in locales) {
        return lang as SupportedLocale
    }
    return defaultLocale
}
